import { useTheme } from "@mui/material/styles";

const PeopleTypeIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="26"
        height="26"
        rx="4"
        fill={theme.palette.otherDivider.main}
      />
      <path
        d="M19.6666 20.5C19.6666 19.337 19.6666 18.7555 19.5231 18.2824C19.1999 17.217 18.3662 16.3834 17.3009 16.0602C16.8277 15.9167 16.2462 15.9167 15.0832 15.9167H10.9166C9.75362 15.9167 9.17213 15.9167 8.69897 16.0602C7.63363 16.3834 6.79995 17.217 6.47678 18.2824C6.33325 18.7555 6.33325 19.337 6.33325 20.5M16.7499 9.25C16.7499 11.3211 15.071 13 12.9999 13C10.9289 13 9.24992 11.3211 9.24992 9.25C9.24992 7.17893 10.9289 5.5 12.9999 5.5C15.071 5.5 16.7499 7.17893 16.7499 9.25Z"
        stroke={theme.palette.text.secondary}
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PeopleTypeIcon;
